export function createConfigurationAppliedNonAuth(data) {
    return {
        name: 'ConfigurationAppliedNonAuth',
        environments: ['devicenonauth', 'browsernonauth'],
        data: data
    };
}
//# sourceMappingURL=createConfigurationAppliedNonAuth.js.map